import moment from "moment";

export function whatsAppFormat(date) {
  const itemDate = new Date(date);
  const today = new Date();
  const a = moment(itemDate);
  const b = moment(today);
  const diff = a.diff(b, "days") * -1; // the diff come with negative values

  if (diff === 0) {
    return "HH:mm";
  } else if (diff > 0 && diff <= 6) {
    return "dddd";
  }

  return "DD/MM/YYYY";
}
